/**
 * The maximum length for a post
 */
export const _maxPostLength = 2400;
